import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EvsStampService } from '../../../../common/services/EvsStamp.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-guarantee-request-list',
  templateUrl: './guarantee-request-list.component.html',
  styleUrls: ['./guarantee-request-list.component.css'],
  providers: [EvsStampService, UploadEvsService]
})
export class GuaranteeRequestListComponent implements OnInit {
  public loading_data: boolean = false;
  public requests: any[] = [];
  
  public activeMainTab: string = 'list';
  public source: number = 0;

  @ViewChild('importFile') importFile: ModalDirective;
  public titleFile = 'Chọn file upload';
  public message: { class: string; content: string; } = null;
  public files: any = null;
  
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  public item_active: number = 0;

  // Filters
  public filter: any = {
    serial: '',
    phone: '',
    name: '',
    status: 2, // Default to Pending (Chờ xử lý)
    created_time: null
  };
  public activeStatusTab: string = 'CHO_XU_LY';

  // Pagination
  public currentPage: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;
  public totalPage: number = 1;
  public pages: number[] = [];

  // Details
  public selectedRequest: any = null;
  public showDetailModal: boolean = false;

  // Reject Modal
  public showRejectModal: boolean = false;
  public rejectRequestId: any = null;
  public rejectReason: string = '';
  public rejectError: string = '';
  public loadingReject: boolean = false;

  // Assignment Modal
  public assignmentConfig: string = 'specific'; // 'specific' hoặc 'shared'
  public showAssignModal: boolean = false;
  public staffList: any[] = [
    { id: '1', name: 'Nhân viên Kỹ thuật A' },
    { id: '2', name: 'Nhân viên CSKH B' },
    { id: '3', name: 'Nhân viên Vận hành C' }
  ];
  public selectedAssignee: any = '';
  public assignRequestSelected: any = null;
  public loadingAssign: boolean = false;

  public showCreateModal: boolean = false;
  public loadingCreate: boolean = false;
  public newRequest: any = {
    serial: '',
    product_id: '',
    customer_name: '',
    customer_phone: '',
    customer_province: '',
    customer_ward: '',
    note: '',
    error_image: ''
  };
  public createErrors: any = {};
  public requestFieldsConfig: any[] = [];

  // Approve Modal
  public showApproveModal: boolean = false;
  public loadingApprove: boolean = false;
  public approveForm: any = {
    newSerial: '',
    productId: '',
    serial: '',
    startDate: new Date(),
    dateReason: '',
    isDateAdjusted: false,
    originalStartDate: new Date()
  };
  public approveErrors: any = {};
  public productList: any[] = [
    { id: 1, name: 'Bếp Từ Đôi Kaff KF-988II' },
    { id: 2, name: 'Tủ Lạnh Electrolux Inverter 350L' },
    { id: 3, name: 'Máy Rửa Bát Kaff KF-W800' }
  ];

  // Excel Export Modal
  public showExportModal: boolean = false;
  public loadingExport: boolean = false;
  public exportConfig: any = {
    titleType: 'label',
    mockRowCount: 500,
    columns: [
      { key: 'code', title: 'Mã yêu cầu', selected: true },
      { key: 'serial', title: 'Mã Serial', selected: true },
      { key: 'product', title: 'Sản phẩm', selected: true },
      { key: 'fullname', title: 'Họ và tên', selected: true },
      { key: 'phone', title: 'Số điện thoại', selected: true },
      { key: 'province', title: 'Tỉnh/Thành phố', selected: true },
      { key: 'ward', title: 'Phường/Xã', selected: true },
      { key: 'reason', title: 'Lý do bảo hành', selected: true },
      { key: 'date', title: 'Ngày gửi', selected: true },
      { key: 'status', title: 'Trạng thái', selected: true }
    ]
  };

  constructor(
    private stampService: EvsStampService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService,
    private uploadService: UploadEvsService
  ) {}

  ngOnInit() {
    const userStr = localStorage.getItem('User');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user && user.source) {
          this.source = Number(user.source);
        }
      } catch (e) {}
    }
    this.loadRequestFieldsConfig();
    this.loadData();
  }

  loadRequestFieldsConfig() {
    this.stampService.getFieldGuarantee({ limit: 100, type: 'request', form_type: 'request' }).subscribe(
      (res: any) => {
        if (!res.error && res.data && res.data.length > 0) {
          const loadedFields: any[] = [];
          const sortedData = [...res.data].sort((a, b) => (a.order || 0) - (b.order || 0));

          let customCount = 0;
          sortedData.forEach((backendField: any) => {
            const defaultField = this.requestFieldsConfig.find(f => f.key === backendField.key) || { isCustom: false };
            const isCustom = backendField.is_custom === 1 || !!backendField.isCustom || defaultField.isCustom === true || false;
            
            // Giới hạn chỉ hiển thị 1-2 trường custom (bổ sung) trên danh sách
            if (isCustom) {
              if (customCount >= 2) return;
              customCount++;
            }

            loadedFields.push({
              key: backendField.key,
              title: backendField.name || backendField.title || defaultField.title || '',
              isVisible: backendField.status === 1 || backendField.status === true,
              isRequired: backendField.require === 1 || backendField.require === true,
              isCustom: isCustom,
              type: backendField.type || defaultField.type || 'text',
              value_f: backendField.value_f || []
            });
          });

          // Append missing default fields (Chỉ giữ đúng 8 trường mặc định chuẩn Lieunt)
          const defaults = [
            { key: 'name', title: 'Họ và tên', isVisible: true, isRequired: false, isCustom: false },
            { key: 'phone', title: 'Số điện thoại', isVisible: true, isRequired: false, isCustom: false },
            { key: 'serial', title: 'Số Serial', isVisible: true, isRequired: false, isCustom: false },
            { key: 'product', title: 'Sản phẩm', isVisible: true, isRequired: false, isCustom: false },
            { key: 'province', title: 'Tỉnh/Thành phố', isVisible: true, isRequired: false, visibleDisabled: false, isCustom: false },
            { key: 'ward', title: 'Phường/Xã', isVisible: true, isRequired: false, visibleDisabled: false, isCustom: false },
            { key: 'reason', title: 'Mô tả lỗi', isVisible: true, isRequired: false, isCustom: false },
            { key: 'error_image', title: 'Hình ảnh lỗi', isVisible: true, isRequired: false, isCustom: false }
          ];
          defaults.forEach(def => {
            if (!loadedFields.some(f => f.key === def.key)) {
              loadedFields.push(def);
            }
          });

          this.requestFieldsConfig = loadedFields;
        } else {
          this.loadLocalConfig();
        }
      },
      (err) => {
        console.error('Error loading config:', err);
        this.loadLocalConfig();
      }
    );
  }

  loadLocalConfig() {
    const configStr = localStorage.getItem('EVS_REQUEST_FIELDS_CONFIG');
    if (configStr) {
      try {
        this.requestFieldsConfig = JSON.parse(configStr);
      } catch (e) {
        this.setDefaultConfig();
      }
    } else {
      this.setDefaultConfig();
    }
  }

  loadData() {
    this.loading_data = true;
    
    // TEMPORARY DIAGNOSTICS: Fetch recent logs without status/state filter
    this.stampService.getLogGuarantee({ limit: 5 })
      .toPromise()
      .then((diagRes: any) => {
        console.log('--- DIAGNOSTICS LOGS:', diagRes);
        if (diagRes.status === 200 && !diagRes.error && diagRes.data && diagRes.data.serial) {
          const listStr = diagRes.data.serial.map((s: any) => `${s.serial} (status: ${s.status}, state: ${s.state})`).join(', ');
          this.toastr.info(`5 logs gần nhất: ${listStr || 'Không có log nào'}`, 'Chẩn đoán', { timeOut: 15000 });
        } else {
          const diagMsg = diagRes ? diagRes.message : '';
          this.toastr.warning(`Không load được logs chẩn đoán: ${diagMsg || 'Không có data'}`);
        }
      })
      .catch((diagErr: any) => {
        console.error('--- DIAGNOSTICS ERROR:', diagErr);
      });
 
    // Prepare query for request logs
    const queryStatus = (this.filter.status !== undefined && this.filter.status !== null) ? Number(this.filter.status) : 2;
    const query: any = {
      state: 6,
      offset: this.page_size * (this.currentPage - 1),
      limit: this.page_size,
      sort_by: 'created_time:desc'
    };
    if (queryStatus !== 0) {
      query.status = queryStatus;
    }
 
    if (this.filter.serial) {
      query.serial = this.filter.serial.trim();
    }
    if (this.filter.phone) {
      query.phone = this.filter.phone.trim();
    }
    if (this.filter.name) {
      query.name = this.filter.name.trim();
    }
    if (this.filter.created_time && this.filter.created_time.length === 2) {
      query.start_time = moment(this.filter.created_time[0]).startOf('day').toISOString();
      query.end_time = moment(this.filter.created_time[1]).endOf('day').toISOString();
    }

    // Add custom fields filters to the query
    this.requestFieldsConfig.forEach(field => {
      if (field.isCustom && this.filter[field.key]) {
        if (typeof this.filter[field.key] === 'string') {
          query[field.key] = this.filter[field.key].trim();
        } else if (this.filter[field.key] instanceof Date) {
          query[field.key] = moment(this.filter[field.key]).toISOString();
        } else {
          query[field.key] = this.filter[field.key];
        }
      }
    });

    this.stampService
      .getLogGuarantee(query)
      .toPromise()
      .then((res: any) => {
        this.loading_data = false;
        if (res.status === 200 && !res.error) {
          this.requests = res.data.serial || [];

          // BA yêu cầu hardcode thêm 2 dòng dữ liệu giả lập cho case Chưa có tem / Chưa có sản phẩm
          const hardcodedData = [
            {
              id: 'mock1', code: 'US-000019', serial: '', product_id: '',
              status: 2, state: 6, created_time: new Date().toISOString(),
              customer: { name: 'Khách hàng Test 19', phone: '0900000019', email: 'test19@gmail.com', address: 'Không có serial' },
              creator_info: { name: 'Khách hàng Test 19', phone: '0900000019', email: 'test19@gmail.com', channel: 'Mobile Web (Iframe)' },
              owner_info: { name: 'Khách hàng Test 19', phone: '0900000019', address: '123 Đường Láng', province: 'Hà Nội', ward: 'Láng Hạ' },
              note: 'Test case: Chưa có serial và sản phẩm (US-000019)', assignee_name: '',
              fields: [
                { name: 'Nơi mua hàng', value: 'Cửa hàng' },
                { name: 'Tên cửa hàng', value: 'Kaff Nguyễn Trãi' }
              ],
              logs: [
                { time: new Date().toISOString(), action: 'Khách hàng gửi yêu cầu bảo hành', actor: 'Khách hàng Test 19', status: 'Chờ xử lý' }
              ]
            },
            {
              id: 'mock2', code: 'US-000020', serial: 'SN-ELEC-9922', product_id: 2,
              status: 2, state: 6, created_time: new Date().toISOString(),
              customer: { name: 'Khách hàng Test 20', phone: '0900000020', email: 'test20@gmail.com', address: 'Có sẵn serial' },
              product: { name: 'Tủ Lạnh Electrolux Inverter 350L', id: 2 },
              creator_info: { name: 'Khách hàng Test 20', phone: '0900000020', email: 'test20@gmail.com', channel: 'Zalo OA Mini App' },
              owner_info: { name: 'Khách hàng Test 20', phone: '0900000020', address: '456 Lê Lợi', province: 'Hồ Chí Minh', ward: 'Bến Nghé' },
              note: 'Test case: Có sẵn serial và sản phẩm (US-000020)', assignee_name: ''
            }
          ];

          if (this.currentPage === 1) {
            this.requests = [...hardcodedData, ...this.requests];
          }

          // BA yêu cầu xem giao diện mock trực tiếp trên các mã thật: TX-012659 và TX-012658
          this.requests.forEach(req => {
            if (req.serial === 'TX-012659') {
              req.status = 1; // Đã duyệt
              req.assignee_name = 'Đoàn Nguyễn Quỳnh Như';
              req.ticket_code = 'TICKET-000293';
              req.logs = [
                { time: new Date(Date.now() - 86400000).toISOString(), action: 'Khách hàng gửi yêu cầu bảo hành', actor: 'Đoàn Nguyễn Quỳnh Như', status: 'Chờ xử lý' },
                { time: new Date(Date.now() - 40000000).toISOString(), action: 'Phân công xử lý', actor: 'Admin Hệ thống', status: 'Đã phân công' },
                { time: new Date().toISOString(), action: 'Tiếp nhận bảo hành', actor: 'Đoàn Nguyễn Quỳnh Như', status: 'Đã tiếp nhận' }
              ];
            } else if (req.serial === 'TX-012658') {
              req.status = 3; // Từ chối
              req.reject_reason = 'Sản phẩm cốc giữ nhiệt bị rơi vỡ do lỗi người dùng, không thuộc diện bảo hành của nhà sản xuất.';
              req.logs = [
                { time: new Date(Date.now() - 86400000).toISOString(), action: 'Khách hàng gửi yêu cầu bảo hành', actor: 'Đoàn Nguyễn Quỳnh Như', status: 'Chờ xử lý' },
                { time: new Date().toISOString(), action: 'Từ chối tiếp nhận', actor: 'Admin Hệ thống', status: 'Từ chối' }
              ];
            }
          });

          // Tự động chọn yêu cầu đầu tiên nếu có dữ liệu
          this.totalRow = res.data.total || this.requests.length;
          this.totalPage = Math.ceil(this.totalRow / this.page_size) || 1;
          this.buildPages();

          if (this.requests.length > 0) {
            this.selectRequest(this.requests[0], 0);
          } else {
            this.selectedRequest = null;
            this.item_active = 0;
          }
        } else {
          this.toastr.error(this.parseErrorMsg(res) || 'Lỗi tải danh sách yêu cầu');
        }
      })
      .catch((err: any) => {
        this.loading_data = false;
        this.toastr.error(this.parseErrorMsg(err) || 'Lỗi kết nối máy chủ');
      });
  }

  buildPages() {
    this.pages = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - 2);
    let endPage = Math.min(this.totalPage, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      this.pages.push(i);
    }
  }

  setPage(page: number) {
    if (page < 1 || page > this.totalPage) return;
    this.currentPage = page;
    this.loadData();
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  onStatusFilterChange(status: string) {
    this.activeStatusTab = status;
    if (status === 'CHO_XU_LY') this.filter.status = 2;
    else if (status === 'DA_TIEP_NHAN') this.filter.status = 1;
    else if (status === 'TU_CHOI') this.filter.status = 3;
    this.search();
  }

  getBadgeStatus(statusNum: number, assignee?: string): string {
    if (statusNum === 1) return 'DA_TIEP_NHAN';
    if (statusNum === 3 || statusNum === 4) return 'TU_CHOI';
    if (assignee) return 'DA_PHAN_CONG';
    return 'CHO_XU_LY';
  }

  reset() {
    this.filter = {
      serial: '',
      phone: '',
      name: '',
      status: 2,
      created_time: null
    };
    this.activeStatusTab = 'CHO_XU_LY';
    this.currentPage = 1;
    this.loadData();
  }

  selectRequest(req: any, index: number) {
    this.selectedRequest = req;
    
    // Đảm bảo luôn có ít nhất 1 log khởi tạo ban đầu nếu dữ liệu gốc không có
    if (!this.selectedRequest.logs || this.selectedRequest.logs.length === 0) {
      const createdTime = this.selectedRequest.created_time || new Date().toISOString();
      const customerName = (this.selectedRequest.customer && this.selectedRequest.customer.name) ? this.selectedRequest.customer.name : 'Khách hàng';
      this.selectedRequest.logs = [
        { time: createdTime, action: 'Khách hàng gửi yêu cầu bảo hành', actor: customerName, status: 'Chờ xử lý' }
      ];
    }
    
    this.item_active = index;
  }

  viewDetail(req: any) {
    this.selectedRequest = req;
    this.showDetailModal = true;
  }

  closeDetail() {
    this.showDetailModal = false;
    this.selectedRequest = null;
  }

  public rejectImageFile: any = null;
  public rejectImagePreview: string = '';

  openRejectModal(req: any) {
    this.rejectRequestId = req.id || req._id;
    this.rejectReason = '';
    this.rejectError = '';
    this.removeRejectImage();
    this.showRejectModal = true;
  }

  closeRejectModal() {
    this.showRejectModal = false;
    this.rejectRequestId = null;
    this.rejectReason = '';
    this.rejectError = '';
    this.removeRejectImage();
  }

  onRejectImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.rejectImageFile = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.rejectImagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeRejectImage() {
    this.rejectImageFile = null;
    this.rejectImagePreview = '';
    // Clear input file
    const input: any = document.querySelector('input[type="file"][accept="image/*"]');
    if (input) input.value = '';
  }

  confirmReject() {
    if (!this.rejectReason || this.rejectReason.trim() === '') {
      this.rejectError = 'Vui lòng nhập lý do từ chối';
      return;
    }
    this.rejectError = '';
    this.loadingReject = true;

    if (String(this.rejectRequestId).startsWith('mock')) {
      setTimeout(() => {
        this.loadingReject = false;
        this.selectedRequest.status = 3;
        this.selectedRequest.reject_reason = this.rejectReason;
        this.toastr.success('Từ chối yêu cầu thành công (Mock)');
        this.closeRejectModal();
      }, 500);
      return;
    }

    const body = Object.assign({}, this.selectedRequest);
    body.status = 4;
    body.delete_reason = this.rejectReason;
    body.note = this.rejectReason;

    this.stampService
      .updateGuaranteeStatusById(this.rejectRequestId, 4, body)
      .toPromise()
      .then((res: any) => {
        this.loadingReject = false;
        this.toastr.success('Từ chối yêu cầu thành công');
        this.closeRejectModal();
        this.loadData();
      })
      .catch((err: any) => {
        this.loadingReject = false;
        this.toastr.error(this.parseErrorMsg(err) || 'Lỗi từ chối yêu cầu');
      });
  }

  formatDate(dateStr: string) {
    if (!dateStr) return '';
    return moment(dateStr).format('DD/MM/YYYY HH:mm');
  }

  openAssignModal(req: any) {
    this.assignRequestSelected = req;
    this.selectedAssignee = req.assignee_name || '';
    this.showAssignModal = true;
  }

  closeAssignModal() {
    this.showAssignModal = false;
    this.assignRequestSelected = null;
    this.selectedAssignee = '';
  }

  confirmAssign() {
    if (!this.selectedAssignee || this.selectedAssignee === '') {
      this.toastr.warning('Vui lòng chọn nhân viên phụ trách');
      return;
    }
    this.loadingAssign = true;
    
    // Giả lập (Mock) gọi API phân công do backend chưa có API chính thức
    setTimeout(() => {
      this.assignRequestSelected.assignee_name = this.selectedAssignee;
      this.loadingAssign = false;
      this.toastr.success('Phân công nhân viên phụ trách thành công');
      this.closeAssignModal();
    }, 600);
  }

  // --- Approve Modal methods ---
  approveRequest(req: any) {
    this.selectedRequest = req;
    const today = new Date();
    this.approveForm = {
      newSerial: '',
      productId: req.product_id || '',
      serial: req.serial || '',
      startDate: today,
      dateReason: '',
      isDateAdjusted: false,
      originalStartDate: today
    };
    this.approveErrors = { productId: '', serial: '', dateReason: '' };
    this.showApproveModal = true;
  }

  closeApproveModal() {
    this.showApproveModal = false;
    this.loadingApprove = false;
  }

  onApproveProductChange() {
    this.approveErrors.productId = '';
  }

  onStartDateChange(val: Date) {
    if (!val || !this.approveForm) return;
    const originalDate = moment(this.approveForm.originalStartDate);
    const newDate = moment(val);
    this.approveForm.isDateAdjusted = !originalDate.isSame(newDate, 'day');
  }

  confirmApprove() {
    this.approveErrors = { productId: '', serial: '', dateReason: '' };
    let hasError = false;

    if (!this.selectedRequest.serial || !this.selectedRequest.product_id) {
      if (!this.approveForm.productId) {
        this.approveErrors.productId = 'Vui lòng chọn sản phẩm tiếp nhận';
        hasError = true;
      }
      if (!this.approveForm.serial || this.approveForm.serial.trim() === '') {
        this.approveErrors.serial = 'Vui lòng nhập số Serial';
        hasError = true;
      }
    }

    if (this.approveForm.isDateAdjusted && (!this.approveForm.dateReason || this.approveForm.dateReason.trim() === '')) {
      this.approveErrors.dateReason = 'Vui lòng nhập lý do điều chỉnh ngày';
      hasError = true;
    }

    if (hasError) return;

    this.loadingApprove = true;

    // Giả lập cuộc gọi API duyệt tiếp nhận & kích hoạt ngầm
    setTimeout(() => {
      this.loadingApprove = false;
      this.selectedRequest.status = 1;
      this.selectedRequest.ticket_code = 'TICKET-' + Math.floor(100000 + Math.random() * 900000);
      
      // Đồng bộ thông tin CRM mới nếu được nhập vào lúc duyệt
      if (!this.selectedRequest.serial || !this.selectedRequest.product_id) {
        this.selectedRequest.serial = this.approveForm.serial.trim();
        this.selectedRequest.product_id = this.approveForm.productId;
        const selectedProd = this.productList.find(p => p.id == this.approveForm.productId);
        this.selectedRequest.product = {
          id: this.approveForm.productId,
          name: selectedProd ? selectedProd.name : 'Sản phẩm mới'
        };
      } else if (this.approveForm.newSerial && this.approveForm.newSerial.trim() !== '') {
        this.selectedRequest.serial = this.approveForm.newSerial.trim();
      }

      this.toastr.success('Phê duyệt yêu cầu và khởi tạo phiếu tiếp nhận thành công!');
      this.closeApproveModal();
    }, 1200);
  }

  // --- Excel Export Modal methods ---
  openExportModal() {
    this.exportConfig.columns.forEach(col => col.selected = true);
    this.exportConfig.mockRowCount = 500;
    this.exportConfig.titleType = 'label';
    this.showExportModal = true;
  }

  closeExportModal() {
    this.showExportModal = false;
    this.loadingExport = false;
  }

  confirmExport() {
    this.loadingExport = true;
    const selectedColumns = this.exportConfig.columns.filter(c => c.selected).map(c => c.title);
    
    if (selectedColumns.length === 0) {
      this.toastr.warning('Vui lòng chọn ít nhất một cột cần xuất');
      this.loadingExport = false;
      return;
    }

    const rowCount = Number(this.exportConfig.mockRowCount);

    if (rowCount > 10000) {
      // Giả lập cơ chế hàng đợi bất đồng bộ (Async Queue)
      setTimeout(() => {
        this.loadingExport = false;
        this.toastr.success('Hệ thống đang tiến hành xuất dữ liệu lớn (> 10,000 dòng) dưới nền. Bạn sẽ nhận được thông báo khi hoàn thành.');
        this.closeExportModal();

        // Giả lập thông báo đẩy hoàn thành sau 3 giây
        setTimeout(() => {
          this.toastr.info('Xuất báo cáo Excel thành công! Bạn có thể tải file từ danh sách Lịch sử xuất file.', 'Thông báo hệ thống', {
            timeOut: 10000,
            closeButton: true
          });
        }, 4000);
      }, 1000);
    } else {
      // Giả lập cơ chế xuất trực tiếp đồng bộ (Sync)
      setTimeout(() => {
        this.loadingExport = false;
        this.toastr.success('Xuất file thành công! Bắt đầu tải file xuống...');
        this.closeExportModal();
      }, 1200);
    }
  }

  rowIndex(i: number) {
    return this.page_size * (this.currentPage - 1) + (i + 1);
  }

  goToListTab() {
    this.activeMainTab = 'list';
    this.loadRequestFieldsConfig();
  }

  setDefaultConfig() {
    this.requestFieldsConfig = [
      { key: 'name', title: 'Họ và tên', isVisible: true, isRequired: false, isCustom: false },
      { key: 'phone', title: 'Số điện thoại', isVisible: true, isRequired: false, isCustom: false },
      { key: 'serial', title: 'Số Serial', isVisible: true, isRequired: false, isCustom: false },
      { key: 'product', title: 'Sản phẩm', isVisible: true, isRequired: false, isCustom: false },
      { key: 'province', title: 'Tỉnh/Thành phố', isVisible: true, isRequired: false, visibleDisabled: false, isCustom: false },
      { key: 'ward', title: 'Phường/Xã', isVisible: true, isRequired: false, visibleDisabled: false, isCustom: false },
      { key: 'reason', title: 'Mô tả lỗi', isVisible: true, isRequired: false, isCustom: false },
      { key: 'error_image', title: 'Hình ảnh đính kèm lỗi', isVisible: true, isRequired: false, isCustom: false }
    ];
  }

  isFieldVisible(key: string): boolean {
    const field = this.requestFieldsConfig.find(f => f.key === key);
    return field ? field.isVisible : false;
  }

  openModalImportFile() {
    this.message = null;
    this.importFile.show();
  }

  closeModalImportFile() {
    this.importFile.hide();
  }

  onChange(event) {
    this.message = null;
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = 'Chọn file upload';
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  clearInputFile() {
    const input = $('#controlFileActiveGuarantee');
    if (input && input.length) {
      input.wrap('<form>').closest('form').get(0).reset();
      input.unwrap();
    }
  }

  submitForm(data) {
    this.titleFile = 'Chọn file upload';

    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      const file_name = file.name;
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file_name.split('.').pop();
      if (this.isInArray(allowedExtensions, fileExtension)) {
        this.message = {
          class: 'alert dark alert-success',
          content: 'Đang thực hiện....'
        };
        this.uploadService.uploadFileActiveGuarantee(file).then((res: any) => {
          if (res.code === 1) {
            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: 'Import file KHBH thành công !!',
            };
            this.toastr.success('Hệ thống đang thực hiện kích hoạt bảo hành cho sản phẩm, vui lòng xem kết quả ở mục Thông báo', '', {
              timeOut: 5000,
            });
            setTimeout(() => {
              this.currentPage = 1;
              this.loadData();
            }, 1000);
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            };
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: 'Vui lòng chọn đúng file Excel.'
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: 'Bạn chưa chọn file để Import.'
      };
    }
    this.clearInputFile();
  }

  getFileTemplete() {
    this.stampService.getFileTemplete().subscribe((res) => {
      const url2 = window.URL.createObjectURL(res);
      const a2 = document.createElement('a');
      document.body.appendChild(a2);
      a2.href = url2;
      a2.download = 'File Mẫu' + '.xlsx';
      a2.click();
      window.URL.revokeObjectURL(url2);
    });
  }

  openCreateRequestModal() {
    this.newRequest = {
      serial: '',
      product_id: '',
      customer_name: '',
      customer_phone: '',
      customer_province: '',
      customer_ward: '',
      note: '',
      error_image: ''
    };
    this.createErrors = {};
    this.showCreateModal = true;
  }

  closeCreateModal() {
    this.showCreateModal = false;
  }

  parseErrorMsg(err: any): string {
    if (!err) return '';
    if (typeof err === 'string') return err;
    if (err.message) {
      if (typeof err.message === 'string') return err.message;
      if (typeof err.message === 'object') {
        return err.message.message || err.message.error || JSON.stringify(err.message);
      }
    }
    if (err.error) {
      if (typeof err.error === 'string') return err.error;
      if (typeof err.error === 'object') {
        return err.error.message || err.error.error || JSON.stringify(err.error);
      }
    }
    return JSON.stringify(err);
  }

  confirmCreateRequest() {
    this.createErrors = {};
    let hasError = false;

    if (!this.newRequest.serial || this.newRequest.serial.trim() === '') {
      this.createErrors.serial = 'Vui lòng nhập mã serial';
      hasError = true;
    }
    if (!this.newRequest.customer_name || this.newRequest.customer_name.trim() === '') {
      this.createErrors.customer_name = 'Vui lòng nhập họ và tên khách hàng';
      hasError = true;
    }
    if (!this.newRequest.customer_phone || this.newRequest.customer_phone.trim() === '') {
      this.createErrors.customer_phone = 'Vui lòng nhập số điện thoại';
      hasError = true;
    }

    if (hasError) return;

    this.loadingCreate = true;

    const body: any = {
      serial_id: this.newRequest.serial.trim(),
      status: 2,
      customer: {
        name: this.newRequest.customer_name.trim(),
        phone: this.newRequest.customer_phone.trim(),
        email: this.newRequest.customer_email.trim(),
        address: this.newRequest.customer_address.trim()
      },
      note: this.newRequest.note ? this.newRequest.note.trim() : '',
      assignee_name: this.assignmentConfig === 'specific' ? this.newRequest.assignee : ''
    };

    this.stampService
      .logGuarantee(body)
      .toPromise()
      .then((res: any) => {
        this.loadingCreate = false;
        if (res.status === 200) {
          this.toastr.success('Thêm mới yêu cầu bảo hành thành công');
          // TEMPORARY DIAGNOSTICS
          const createdLog = res.data || {};
          const logId = createdLog.id || createdLog._id || 'N/A';
          const logStatus = createdLog.status !== undefined ? createdLog.status : 'N/A';
          const logState = createdLog.state !== undefined ? createdLog.state : 'N/A';
          this.toastr.info(`Tạo thành công: ID: ${logId}, status: ${logStatus}, state: ${logState}`, 'Chi tiết tạo', { timeOut: 15000 });
          this.closeCreateModal();
          this.loadData();
        } else {
          this.toastr.error(this.parseErrorMsg(res) || 'Lỗi thêm mới yêu cầu bảo hành');
        }
      })
      .catch((err: any) => {
        this.loadingCreate = false;
        this.toastr.error(this.parseErrorMsg(err) || 'Lỗi thêm mới yêu cầu bảo hành');
      });
  }

  get errorImages(): string[] {
    if (!this.selectedRequest) return [];
    if (this.selectedRequest.images && this.selectedRequest.images.length > 0) {
      return this.selectedRequest.images;
    }
    if (this.selectedRequest.error_image) {
      if (Array.isArray(this.selectedRequest.error_image)) {
        return this.selectedRequest.error_image;
      }
      if (typeof this.selectedRequest.error_image === 'string') {
        return this.selectedRequest.error_image.split(',').map(s => s.trim()).filter(Boolean);
      }
    }
    return [];
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/guarantee-request-list.component.ts